module.exports = __webpack_public_path__ + "img/banner-Image-text-bg.3853aca3.png";